import { inject } from '@angular/core'
import { OnDemandService } from '../../../_core/_services/on-demand.service'
import { Component,
         ElementRef,
         EventEmitter,
         Input,
         OnInit,
         OnDestroy,
         Output,
         ViewChild } from '@angular/core'

import { KeyboardService,
         RouterService } from 'src/app/_core/index'

@Component({
  selector: 'ss-popup',
  templateUrl: 'popup.component.html',
  styleUrls: ['popup.component.scss'],
})
export class PopupComponent implements OnInit, OnDestroy {

  @Input('ssOutlet') outlet = 'p'

  @Output() onClose = new EventEmitter<any>()

  @ViewChild('popupContent', {read: ElementRef}) popupContent: any

  keyboard$: any

  mouseDownTarget: ElementRef

  private onDemandService = inject(OnDemandService)

  constructor(
    private el: ElementRef,
    private keyboardService: KeyboardService,
    private routerService: RouterService
  ) {}

  ngOnInit() {
    this.onDemandService.loadFontAwesome()
    this.keyboard$ = this.keyboardStream()
  }

  ngOnDestroy() {
    this.routerService.setTitleFromPrimarySubjects()
    if (this.keyboard$) this.keyboard$.unsubscribe()
  }

  keyboardStream() {
    return this.keyboardService.keyboardResponse.subscribe((res: any) => {
      if (res === 'close-popup') this.closePopup()
    })
  }

  closePopup(e?:any) {
    this.routerService.closeOutlet(this.outlet)
    this.onClose.emit(true)
  }

  onSelectWrapper(e: any) {
    if (this.eventOnTarget(e)) return
    this.closePopup()
  }

  eventOnTarget(event: any): boolean {
    if (!this.popupContent) { console.warn('!popupContent'); return }
    // console.log('eot-popup', this.popupContent.nativeElement, this.el.nativeElement.contains(this.popupContent.nativeElement))

    return this.popupContent.nativeElement.contains(event.target) // .contains(this.popupContent.nativeElement)
  }
}
